import React from 'react';
import { t } from 'ttag';
import { generatePath } from 'react-router-dom';

import { AnimatedPageBanner } from '@components/AnimatedPageBanner';
import { Image } from '@ui/Image';
import { Title } from '@ui/Title';
import { Stars } from '@ui/Stars';
import { memberReviewRequest } from '@urls';
import { UserRole } from '@newModels';

import s from './AnimatedReviewBanner.sss';

type Props = {
  reviewRequest: {
    threadId: number,
    userRole: UserRole,
    userTo?: Maybe<{ avatar: string, username: string, }>,
    dialog?: Maybe<{
      previewImages?: Maybe<string[]>,
      totalPrice?: Maybe<string>,
    }>
  },
  onClose: () => void,
};

export const AnimatedReviewBanner: React.FC<Props> = ({
  reviewRequest: { userTo, dialog, threadId, userRole },
  onClose,
}) => (
  <AnimatedPageBanner
    isVisible={true}
    onClose={onClose}
    rootClassName={s.banner}
    containerClassName={s.root}
  >
    {userTo && (
      <Image
        className={s.userAvatar}
        width="40"
        height="40"
        src={userTo.avatar}
        alt={userTo.username}
      />
    )}
    <Title className={s.title} type="h3">
      {t`Оцініть останню угоду`}
    </Title>
    <div className={s.description}>{t`Залиште відгук про продавця та речі, які ви купили`}</div>
    <div className={s.products}>
      {dialog?.previewImages && (
        dialog.previewImages.length === 1
          ? <Image className={s.productImage} width="40" height="56" src={dialog.previewImages[0]} alt="Image" />
          : (
            <div className={s.imageSide}>
              <Image
                width={32}
                className={s.firstImage}
                src={dialog.previewImages[0]}
                alt="Image"
              />
              <Image
                width={32}
                className={s.secondImage}
                src={dialog.previewImages[1]}
                alt="Image"
              />
            </div>
          )
      )}
      {dialog?.totalPrice && (
        <span>
          {t`Товарів на суму`}
          {' '}
          {dialog?.totalPrice}
          {' '}
          грн
        </span>
      )}
    </div>
    <Stars
      value={0}
      onClick={(value) => {
        window.location.href = `${generatePath(
          memberReviewRequest,
          {
            threadId,
            role: userRole === UserRole.Seller ? 'review-seller' : 'review-buyer',
          },
        )}?rating=${value}`;
      }}
      width={40}
      height={40}
      gap={16}
    />
  </AnimatedPageBanner>
);
